export const getDescription = (count, tagName) => {
  return `${count} Articles found for "${tagName}"`;
};
